import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DashboardLayout } from '../../../Layout/DashboardLayout'
import CustomTable from '../../../Components/CustomTable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faSearch } from '@fortawesome/free-solid-svg-icons'
import BASEURL from '../../../Config/global'
import axios from 'axios'
import CustomFilters from '../../../Components/CustomFilters'
import { PermissionsContext } from '../../../Layout/PermissionContext'
import BackButton from '../../../Components/BackButton'
import CustomLoader from '../../../Components/CustomLoader'

const AddScofaFeaturedMix = () => {
    const { permissions } = useContext(PermissionsContext)
    const navigate = useNavigate()
    const [config, setConfig] = useState({ error: false, msg: '', value: '', loader: false });
    const [soundMixList, setSoundMixList] = useState([]);
    const [enteries, setEnteries] = useState(10);
    const [offset, setOffset] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedLanguage, setSelectedLanguage] = useState("english");

    const header = [
        {
            key: "id",
            title: "Mix ID",
        },
        {
            key: "title",
            title: "Title",
        },
        {
            key: "user",
            title: "User Email",
        },
        {
            key: "actions",
            title: "Action",
        },
    ];

    const getFeaturedListByEmail = async () => {
        try {
            if (config?.value === "" || config?.value === null) {
                return
            }
            setConfig({ ...config, loader: true, error: false });
            const languageParam = selectedLanguage === "spanish" ? "&language=spanish" : "";
            const response = await axios.get(`${BASEURL}/api/sounds/user_mix?limit=${enteries}&offset=${offset}&search=${config?.value}${languageParam}`);
            setConfig({ ...config, loader: false });
            if (response.data.count === 0 && response.data.data.length === 0) {
                setSoundMixList([])
                setConfig({ ...config, error: true, msg: "No Record Found" });
                setTotalCount(0);
            } else {
                setSoundMixList(response?.data?.data)
                setTotalCount(response?.data?.count);
            }
        } catch (error) {
            setSoundMixList([])
            setConfig({ ...config, error: true, msg: "No Record Found", loader: false });
        }
    }

    const handleAddToScofa = (mixer_id) => {
        // Redirect to the Scofa-specific edit page for this mix, 
        // which will allow setting categories and the scofa_flag on save.
        navigate(`/scofa/featured-mix/edit/${mixer_id}?language=${selectedLanguage}`)
    }

    const handleChangeEntries = (no) => {
        setOffset(0)
        setEnteries(no)
    }

    return (
        <>
            <DashboardLayout>
                <div className='container-fluid'>
                    <div className="row mb-3">
                        <div className="col-12 mb-2">
                            <h2 className="mainTitle">
                                <BackButton />
                                Add Highlight Mix to Scofa
                            </h2>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-12">
                            <p className="secondaryText mb-3">Search for a user mix by email to add it to the Scofa dashboard.</p>
                        </div>
                        <div className="col-md-6">
                            <CustomFilters
                                enteries={enteries}
                                totalCount={totalCount}
                                entriesFilter={true}
                                setEnteries={handleChangeEntries}
                            />
                        </div>
                        <div className="col-md-6 text-end">
                            <form autoComplete="off" onSubmit={(event) => {
                                event.preventDefault()
                                getFeaturedListByEmail()
                            }} className="searchWrapper w-100 ms-auto" style={{ maxWidth: '500px' }}>
                                <input
                                    type="text"
                                    placeholder="Please enter user email"
                                    name="search"
                                    className="filterInput searchInput w-100"
                                    autoComplete='off'
                                    value={config?.value}
                                    onChange={(event) => {
                                        setConfig({ ...config, value: event.target.value?.trim() });
                                    }}
                                />
                                <button type='submit' className="searchButton notButton">
                                    <FontAwesomeIcon icon={faSearch} />
                                </button>
                            </form>
                        </div>
                    </div>

                    <CustomTable headers={header}>
                        <tbody>
                            {(!config.loader && soundMixList.length > 0) ? (
                                soundMixList?.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{item.id}</td>
                                        <td>{item.name}</td>
                                        <td>{config.value}</td>
                                        <td>
                                            <button
                                                className="customButton primaryButton p-2"
                                                onClick={() => handleAddToScofa(item.id)}
                                                title="Select and Set Details"
                                            >
                                                <FontAwesomeIcon icon={faPlus} className="me-1" /> Select
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    {config.error && <td colSpan="4" className="text-center">{config.msg}</td>}
                                    {!config.error && !config.loader && soundMixList.length === 0 && <td colSpan="4" className="text-center">Please search for a mix by user email</td>}
                                    {config.loader && <td colSpan="4" className="text-center"> <div className="spinner-border" role="status"></div></td>}
                                </tr>
                            )}
                        </tbody>
                    </CustomTable>
                </div>
            </DashboardLayout>
            {config.loader && <CustomLoader />}
        </>
    )
}

export default AddScofaFeaturedMix
